import React, { useState, useEffect } from 'react';
import Popover from './Popover';
import viewIcon from "../../assets/images/cst-view-icon.svg";
import downIcon from "../../assets/images/cst-download.svg";

function CSTDayCalendar() {
  const [popoverVisible, setPopoverVisible] = useState(false);
  const [popoverPosition, setPopoverPosition] = useState({});
  const [popoverContent, setPopoverContent] = useState("");
  const [filtersVisible, setFiltersVisible] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1024);

  // Function to show popover
  const showPopover = (event, contentId) => {
    const rect = event.target.getBoundingClientRect();
    const contentElement = document.getElementById(contentId);

    if (contentElement) {
      setPopoverContent(contentElement.innerHTML);
    } else {
      setPopoverContent("<p>No content found</p>");
    }

    setPopoverPosition({ top: rect.top, left: rect.left, width: rect.width });
    setPopoverVisible(true);
  };

  // Detect if screen is mobile or desktop
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 1024);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
    
  return (
      <>
          <div className="dayview-container">
              <div className={`pageFilters ${filtersVisible || !isMobile ? "visible" : ""}`}>
                  <div className="filtersCalendar">
                      <div className="monthSelector">
                          <button className="prev-btn"><i className="arrow-icon"></i></button>
                          <p><i className="month-icon"></i> February, 2025</p>
                          <button className="next-btn"><i className="arrow-icon"></i></button>
                      </div>

                      <div className="daySelector">
                          <button className="prev-btn"><i className="arrow-icon"></i></button>
                          <ul id='dayChanger'>
                              <li><span>T</span> 4</li>
                              <li className='active'><span>W</span> 5</li>
                              <li><span>T</span> 6</li>
                          </ul>
                          <button className="next-btn"><i className="arrow-icon"></i></button>
                      </div>

                      <button className="swith-view-btn"><i className="swith-icon"></i> <span>Switch to monthly view</span></button>
                  </div>

                  <div className="otherFiltes">
                      <div className="langTeamFilters">
                          <div className="langsGrp">
                            <label id="chikLabel">Language</label>
                            <div className="radioGrp">
                                <input type="radio" id="tel" name="lang" value="" />
                                <label for="tel">Telugu</label>
                            </div>
                            <div className="radioGrp">
                                <input type="radio" id="tam" name="lang" value="" />
                                <label for="tam">Tamil</label>
                            </div>
                            <div className="radioGrp">
                                <input type="radio" id="kan" name="lang" value="" />
                                <label for="kan">Kannada</label>
                            </div>
                            <div className="radioGrp">
                                <input type="radio" id="hin" name="lang" value="" />
                                <label for="hin">Hindi</label>
                            </div>
                            <div className="radioGrp">
                                <input type="radio" id="ben" name="lang" value="" />
                                <label for="ben">Bengali</label>
                            </div>
                            <div className="radioGrp">
                                <input type="radio" id="mar" name="lang" value="" />
                                <label for="mar">Marati</label>
                            </div>
                            <div className="radioGrp">
                                <input type="radio" id="mal" name="lang" value="" />
                                <label for="mal">Malayalam</label>
                            </div>
                          </div>

                          <div className="teamsGrp">
                            <label id="chikLabel">Team</label>
                            <div className="radioGrp">
                                <input type="radio" id="nat" name="team" value="" />
                                <label for="nat">National</label>
                            </div>
                            <div className="radioGrp">
                                <input type="radio" id="loc" name="team" value="" />
                                <label for="loc">Local</label>
                            </div>
                              <div className="subGrp">
                                <div className="radioGrp">
                                    <input type="radio" id="met" name="sub" value="" />
                                    <label for="met">Metro</label>
                                </div>
                                <div className="radioGrp">
                                    <input type="radio" id="phnx" name="sub" value="" />
                                    <label for="phnx">Phoenix</label>
                                </div>                                  
                                <div className="radioGrp">
                                    <input type="radio" id="ins" name="sub" value="" />
                                    <label for="ins">Inside</label>
                                </div>
                                <div className="radioGrp">
                                    <input type="radio" id="alp" name="sub" value="" />
                                    <label for="alp">Alpha</label>
                                </div>
                            </div>
                          </div>
                      </div>
                      <div className="chooseLocations">
                          <select name="state" id="state">
                              <option value="Select State" selected>Select State</option>
                              <option value="Andhra Pradesh">Andhra Pradesh</option>
                              <option value="Telangana">Telangana</option>
                              <option value="HCR">Hyd Capital Region</option>
                          </select>
                          <select name="district" id="district">
                              <option value="Select District" selected>Select District</option>
                              <option value="">---</option>
                          </select>
                          <select name="constituency" id="constituency">
                              <option value="Select Constituency" selected>Select Constituency</option>
                              <option value="">---</option>
                          </select>
                          <div className="searchBar desktopOnly">
                              <input type="text" name="search" id="search" placeholder="enter order/brand/campaign" />
                          </div>
                      </div>
                      <div className="chooseBy">
                          <div className="selctGrp">
                              <label for="">Order Name</label>
                              <select name="order" id="">
                                <option value="Order Name" selected>Order Name</option>
                                <option value="">---</option>
                              </select>
                          </div>
                          <div className="selctGrp">
                              <label for="">Brand Name</label>
                              <select name="constituency" id="">
                                <option value="Brand Name" selected>Brand Name</option>
                                <option value="">---</option>
                              </select>
                          </div>
                          <div className="selctGrp">
                              <label for="">Creative Type</label>
                              <select name="" id="">
                                <option value="Creative Type" selected>Creative Type</option>
                                <option value="">---</option>
                              </select>
                          </div>
                          <div className="selctGrp">
                              <label for="">Ad Location</label>
                              <select name="" id="">
                                <option value="Ad Location" selected>Ad Location</option>
                                <option value="">---</option>
                              </select>
                          </div>
                          <div className="selctGrp">
                              <label for="">Type of Campaign</label>
                              <select name="" id="">
                                <option value="Type of Campaign" selected>Type of Campaign</option>
                                <option value="">---</option>
                              </select>
                          </div>
                          <div className="selctGrp">
                              <label for="">Ad Position</label>
                              <select name="" id="">
                                <option value="Ad Position" selected>Ad Position</option>
                                <option value="">---</option>
                              </select>
                          </div>
                          <div className="selctGrp">
                              <label for="">Ad Pub. Date</label>
                              <input type="date" name="date" id="pubDate" value='' placeholder='' />
                          </div>
                          <div className="selctGrp">
                              <label for="">Sales Executive</label>
                              <select name="" id="">
                                <option value="Sales Executive" selected>Sales Executive</option>
                                <option value="">---</option>
                              </select>
                          </div>
                          <div className="selctGrp">
                              <label for="">Billing Type</label>
                              <select name="" id="">
                                <option value="Billing Type" selected>Billing Type</option>
                                <option value="">---</option>
                              </select>
                          </div>
                          <div className="selctGrp">
                              <label for="">Payment Method</label>
                              <select name="" id="">
                                <option value="Payment Method" selected>Payment Method</option>
                                <option value="">---</option>
                              </select>
                          </div>
                      </div>                      
                  </div>

                  <div className="resetBtn">
                      <div className="searchBar mobileOnly">
                        <input type="text" name="search" id="search" placeholder="enter order/brand/campaign" />
                      </div>
                      <button className=""><i className='reset'></i> Reset Filters</button>
                  </div>
              </div>

              <div className="cstDayCalender">
                  <div className="cstStickyHeader desktopOnly">
                      <ul>
                          <li>Order Name</li>
                          <li>Brand Name</li>
                          <li>Creative Type</li>
                          <li>Ad Position</li>
                          <li>State</li>
                          <li>District</li>
                          <li>Constituency</li>
                          <li>Campaign Type</li>
                          <li>Ad Pub. Date</li>
                          <li>Ad Cost</li>
                          <li>RO</li>
                      </ul>
                  </div>
                  <div className="cstDayCalenderBody">
                      <ul className='filterResults'>
                          <li>
                              <p><em className='mobileOnly'>Order Name</em> <span title='Kalamandir Promotional Ad'>Kalamandir Promotional Ad</span></p>
                              <p><em className='mobileOnly'>Brand Name</em> <span title='Kalamandir Silks'>Kalamandir Silks</span></p>
                              <p><em className='mobileOnly'>Creative Type</em> <span title='Promoted Image Story'>Promoted Image Story</span></p>
                              <p><em className='mobileOnly'>Ad Position</em> <button className='adPosBtn'>P1</button></p>
                              <p><em className='mobileOnly'>State</em> <span>Telangana</span></p>
                              <p><em className='mobileOnly'>District</em> <span>Karimnagar</span></p>
                              <p><em className='mobileOnly'>Constituency</em> <span>Ramagundam</span></p>
                              <p><em className='mobileOnly'>Campaign Type</em> <span>CPD</span></p>
                              <p><em className='mobileOnly'>Ad Pub. Date</em> <span>5/02/2025</span></p>
                              <p><em className='mobileOnly'>Ad Cost</em> <span>₹ 12,750 </span><i id='roSplitView' onClick={(e) => showPopover(e, 'popover-content')}></i></p>
                              <div class="posActions">
                                  <button className='viewBtn'><img src={viewIcon} alt="" />View</button>
                                  <button className='downBtn'><img src={downIcon} alt="" />Download</button>
                              </div>
                          </li>
                          <li>
                              <p><em className='mobileOnly'>Order Name</em> <span title='Kalamandir Promotional Ad'>Kalamandir Promotional Ad</span></p>
                              <p><em className='mobileOnly'>Brand Name</em> <span title='Kalamandir Silks'>Kalamandir Silks</span></p>
                              <p><em className='mobileOnly'>Creative Type</em> <span title='Promoted Image Story'>Promoted Image Story</span></p>
                              <p><em className='mobileOnly'>Ad Position</em> <button className='adPosBtn'>P3</button></p>
                              <p><em className='mobileOnly'>State</em> <span>Telangana</span></p>
                              <p><em className='mobileOnly'>District</em> <span>Karimnagar</span></p>
                              <p><em className='mobileOnly'>Constituency</em> <span>Ramagundam</span></p>
                              <p><em className='mobileOnly'>Campaign Type</em> <span>CPD</span></p>
                              <p><em className='mobileOnly'>Ad Pub. Date</em> <span>5/02/2025</span></p>
                              <p><em className='mobileOnly'>Ad Cost</em> <span>₹ 12,750 </span><i id='roSplitView' className='hidden' onClick={(e) => showPopover(e, 'popover-content')}></i></p>
                              <div class="posActions">
                                  <button className='viewBtn'><img src={viewIcon} alt="" />View</button>
                                  <button className='downBtn'><img src={downIcon} alt="" />Download</button>
                              </div>
                          </li>
                          <li>
                              <p><em className='mobileOnly'>Order Name</em> <span title='Kalamandir Promotional Ad'>Kalamandir Promotional Ad</span></p>
                              <p><em className='mobileOnly'>Brand Name</em> <span title='Kalamandir Silks'>Kalamandir Silks</span></p>
                              <p><em className='mobileOnly'>Creative Type</em> <span title='Promoted Image Story'>Promoted Image Story</span></p>
                              <p><em className='mobileOnly'>Ad Position</em> <button className='adPosBtn'>P5</button></p>
                              <p><em className='mobileOnly'>State</em> <span>Telangana</span></p>
                              <p><em className='mobileOnly'>District</em> <span>Karimnagar</span></p>
                              <p><em className='mobileOnly'>Constituency</em> <span>Ramagundam</span></p>
                              <p><em className='mobileOnly'>Campaign Type</em> <span>CPD</span></p>
                              <p><em className='mobileOnly'>Ad Pub. Date</em> <span>5/02/2025</span></p>
                              <p><em className='mobileOnly'>Ad Cost</em> <span>₹ 12,750 </span><i id='roSplitView' onClick={(e) => showPopover(e, 'popover-content')}></i></p>
                              <div class="posActions">
                                  <button className='viewBtn'><img src={viewIcon} alt="" />View</button>
                                  <button className='downBtn'><img src={downIcon} alt="" />Download</button>
                              </div>
                          </li>
                          <li>
                              <p><em className='mobileOnly'>Order Name</em> <span title='Kalamandir Promotional Ad'>Kalamandir Promotional Ad</span></p>
                              <p><em className='mobileOnly'>Brand Name</em> <span title='Kalamandir Silks'>Kalamandir Silks</span></p>
                              <p><em className='mobileOnly'>Creative Type</em> <span title='Promoted Image Story'>Promoted Image Story</span></p>
                              <p><em className='mobileOnly'>Ad Position</em> <button className='adPosBtn'>P1</button></p>
                              <p><em className='mobileOnly'>State</em> <span>Telangana</span></p>
                              <p><em className='mobileOnly'>District</em> <span>Karimnagar</span></p>
                              <p><em className='mobileOnly'>Constituency</em> <span>Ramagundam</span></p>
                              <p><em className='mobileOnly'>Campaign Type</em> <span>CPD</span></p>
                              <p><em className='mobileOnly'>Ad Pub. Date</em> <span>5/02/2025</span></p>
                              <p><em className='mobileOnly'>Ad Cost</em> <span>₹ 12,750 </span><i id='roSplitView' onClick={(e) => showPopover(e, 'popover-content')}></i></p>
                              <div class="posActions">
                                  <button className='viewBtn'><img src={viewIcon} alt="" />View</button>
                                  <button className='downBtn'><img src={downIcon} alt="" />Download</button>
                              </div>
                          </li>
                          <li>
                              <p><em className='mobileOnly'>Order Name</em> <span title='Kalamandir Promotional Ad'>Kalamandir Promotional Ad</span></p>
                              <p><em className='mobileOnly'>Brand Name</em> <span title='Kalamandir Silks'>Kalamandir Silks</span></p>
                              <p><em className='mobileOnly'>Creative Type</em> <span title='Promoted Image Story'>Promoted Image Story</span></p>
                              <p><em className='mobileOnly'>Ad Position</em> <button className='adPosBtn'>P3</button></p>
                              <p><em className='mobileOnly'>State</em> <span>Telangana</span></p>
                              <p><em className='mobileOnly'>District</em> <span>Karimnagar</span></p>
                              <p><em className='mobileOnly'>Constituency</em> <span>Ramagundam</span></p>
                              <p><em className='mobileOnly'>Campaign Type</em> <span>CPD</span></p>
                              <p><em className='mobileOnly'>Ad Pub. Date</em> <span>5/02/2025</span></p>
                              <p><em className='mobileOnly'>Ad Cost</em> <span>₹ 12,750 </span><i id='roSplitView' className='hidden' onClick={(e) => showPopover(e, 'popover-content')}></i></p>
                              <div class="posActions">
                                  <button className='viewBtn'><img src={viewIcon} alt="" />View</button>
                                  <button className='downBtn'><img src={downIcon} alt="" />Download</button>
                              </div>
                          </li>
                          <li>
                              <p><em className='mobileOnly'>Order Name</em> <span title='Kalamandir Promotional Ad'>Kalamandir Promotional Ad</span></p>
                              <p><em className='mobileOnly'>Brand Name</em> <span title='Kalamandir Silks'>Kalamandir Silks</span></p>
                              <p><em className='mobileOnly'>Creative Type</em> <span title='Promoted Image Story'>Promoted Image Story</span></p>
                              <p><em className='mobileOnly'>Ad Position</em> <button className='adPosBtn'>P5</button></p>
                              <p><em className='mobileOnly'>State</em> <span>Telangana</span></p>
                              <p><em className='mobileOnly'>District</em> <span>Karimnagar</span></p>
                              <p><em className='mobileOnly'>Constituency</em> <span>Ramagundam</span></p>
                              <p><em className='mobileOnly'>Campaign Type</em> <span>CPD</span></p>
                              <p><em className='mobileOnly'>Ad Pub. Date</em> <span>5/02/2025</span></p>
                              <p><em className='mobileOnly'>Ad Cost</em> <span>₹ 12,750 </span><i id='roSplitView' onClick={(e) => showPopover(e, 'popover-content')}></i></p>
                              <div class="posActions">
                                  <button className='viewBtn'><img src={viewIcon} alt="" />View</button>
                                  <button className='downBtn'><img src={downIcon} alt="" />Download</button>
                              </div>
                          </li>
                          <li>
                              <p><em className='mobileOnly'>Order Name</em> <span title='Kalamandir Promotional Ad'>Kalamandir Promotional Ad</span></p>
                              <p><em className='mobileOnly'>Brand Name</em> <span title='Kalamandir Silks'>Kalamandir Silks</span></p>
                              <p><em className='mobileOnly'>Creative Type</em> <span title='Promoted Image Story'>Promoted Image Story</span></p>
                              <p><em className='mobileOnly'>Ad Position</em> <button className='adPosBtn'>P1</button></p>
                              <p><em className='mobileOnly'>State</em> <span>Telangana</span></p>
                              <p><em className='mobileOnly'>District</em> <span>Karimnagar</span></p>
                              <p><em className='mobileOnly'>Constituency</em> <span>Ramagundam</span></p>
                              <p><em className='mobileOnly'>Campaign Type</em> <span>CPD</span></p>
                              <p><em className='mobileOnly'>Ad Pub. Date</em> <span>5/02/2025</span></p>
                              <p><em className='mobileOnly'>Ad Cost</em> <span>₹ 12,750 </span><i id='roSplitView' onClick={(e) => showPopover(e, 'popover-content')}></i></p>
                              <div class="posActions">
                                  <button className='viewBtn'><img src={viewIcon} alt="" />View</button>
                                  <button className='downBtn'><img src={downIcon} alt="" />Download</button>
                              </div>
                          </li>
                          <li>
                              <p><em className='mobileOnly'>Order Name</em> <span title='Kalamandir Promotional Ad'>Kalamandir Promotional Ad</span></p>
                              <p><em className='mobileOnly'>Brand Name</em> <span title='Kalamandir Silks'>Kalamandir Silks</span></p>
                              <p><em className='mobileOnly'>Creative Type</em> <span title='Promoted Image Story'>Promoted Image Story</span></p>
                              <p><em className='mobileOnly'>Ad Position</em> <button className='adPosBtn'>P3</button></p>
                              <p><em className='mobileOnly'>State</em> <span>Telangana</span></p>
                              <p><em className='mobileOnly'>District</em> <span>Karimnagar</span></p>
                              <p><em className='mobileOnly'>Constituency</em> <span>Ramagundam</span></p>
                              <p><em className='mobileOnly'>Campaign Type</em> <span>CPD</span></p>
                              <p><em className='mobileOnly'>Ad Pub. Date</em> <span>5/02/2025</span></p>
                              <p><em className='mobileOnly'>Ad Cost</em> <span>₹ 12,750 </span><i id='roSplitView' className='hidden' onClick={(e) => showPopover(e, 'popover-content')}></i></p>
                              <div class="posActions">
                                  <button className='viewBtn'><img src={viewIcon} alt="" />View</button>
                                  <button className='downBtn'><img src={downIcon} alt="" />Download</button>
                              </div>
                          </li>
                          <li>
                              <p><em className='mobileOnly'>Order Name</em> <span title='Kalamandir Promotional Ad'>Kalamandir Promotional Ad</span></p>
                              <p><em className='mobileOnly'>Brand Name</em> <span title='Kalamandir Silks'>Kalamandir Silks</span></p>
                              <p><em className='mobileOnly'>Creative Type</em> <span title='Promoted Image Story'>Promoted Image Story</span></p>
                              <p><em className='mobileOnly'>Ad Position</em> <button className='adPosBtn'>P5</button></p>
                              <p><em className='mobileOnly'>State</em> <span>Telangana</span></p>
                              <p><em className='mobileOnly'>District</em> <span>Karimnagar</span></p>
                              <p><em className='mobileOnly'>Constituency</em> <span>Ramagundam</span></p>
                              <p><em className='mobileOnly'>Campaign Type</em> <span>CPD</span></p>
                              <p><em className='mobileOnly'>Ad Pub. Date</em> <span>5/02/2025</span></p>
                              <p><em className='mobileOnly'>Ad Cost</em> <span>₹ 12,750 </span><i id='roSplitView' onClick={(e) => showPopover(e, 'popover-content')}></i></p>
                              <div class="posActions">
                                  <button className='viewBtn'><img src={viewIcon} alt="" />View</button>
                                  <button className='downBtn'><img src={downIcon} alt="" />Download</button>
                              </div>
                          </li>
                          <li>
                              <p><em className='mobileOnly'>Order Name</em> <span title='Kalamandir Promotional Ad'>Kalamandir Promotional Ad</span></p>
                              <p><em className='mobileOnly'>Brand Name</em> <span title='Kalamandir Silks'>Kalamandir Silks</span></p>
                              <p><em className='mobileOnly'>Creative Type</em> <span title='Promoted Image Story'>Promoted Image Story</span></p>
                              <p><em className='mobileOnly'>Ad Position</em> <button className='adPosBtn'>P1</button></p>
                              <p><em className='mobileOnly'>State</em> <span>Telangana</span></p>
                              <p><em className='mobileOnly'>District</em> <span>Karimnagar</span></p>
                              <p><em className='mobileOnly'>Constituency</em> <span>Ramagundam</span></p>
                              <p><em className='mobileOnly'>Campaign Type</em> <span>CPD</span></p>
                              <p><em className='mobileOnly'>Ad Pub. Date</em> <span>5/02/2025</span></p>
                              <p><em className='mobileOnly'>Ad Cost</em> <span>₹ 12,750 </span><i id='roSplitView' onClick={(e) => showPopover(e, 'popover-content')}></i></p>
                              <div class="posActions">
                                  <button className='viewBtn'><img src={viewIcon} alt="" />View</button>
                                  <button className='downBtn'><img src={downIcon} alt="" />Download</button>
                              </div>
                          </li>
                          <li>
                              <p><em className='mobileOnly'>Order Name</em> <span title='Kalamandir Promotional Ad'>Kalamandir Promotional Ad</span></p>
                              <p><em className='mobileOnly'>Brand Name</em> <span title='Kalamandir Silks'>Kalamandir Silks</span></p>
                              <p><em className='mobileOnly'>Creative Type</em> <span title='Promoted Image Story'>Promoted Image Story</span></p>
                              <p><em className='mobileOnly'>Ad Position</em> <button className='adPosBtn'>P3</button></p>
                              <p><em className='mobileOnly'>State</em> <span>Telangana</span></p>
                              <p><em className='mobileOnly'>District</em> <span>Karimnagar</span></p>
                              <p><em className='mobileOnly'>Constituency</em> <span>Ramagundam</span></p>
                              <p><em className='mobileOnly'>Campaign Type</em> <span>CPD</span></p>
                              <p><em className='mobileOnly'>Ad Pub. Date</em> <span>5/02/2025</span></p>
                              <p><em className='mobileOnly'>Ad Cost</em> <span>₹ 12,750 </span><i id='roSplitView' className='hidden' onClick={(e) => showPopover(e, 'popover-content')}></i></p>
                              <div class="posActions">
                                  <button className='viewBtn'><img src={viewIcon} alt="" />View</button>
                                  <button className='downBtn'><img src={downIcon} alt="" />Download</button>
                              </div>
                          </li>
                          <li>
                              <p><em className='mobileOnly'>Order Name</em> <span title='Kalamandir Promotional Ad'>Kalamandir Promotional Ad</span></p>
                              <p><em className='mobileOnly'>Brand Name</em> <span title='Kalamandir Silks'>Kalamandir Silks</span></p>
                              <p><em className='mobileOnly'>Creative Type</em> <span title='Promoted Image Story'>Promoted Image Story</span></p>
                              <p><em className='mobileOnly'>Ad Position</em> <button className='adPosBtn'>P5</button></p>
                              <p><em className='mobileOnly'>State</em> <span>Telangana</span></p>
                              <p><em className='mobileOnly'>District</em> <span>Karimnagar</span></p>
                              <p><em className='mobileOnly'>Constituency</em> <span>Ramagundam</span></p>
                              <p><em className='mobileOnly'>Campaign Type</em> <span>CPD</span></p>
                              <p><em className='mobileOnly'>Ad Pub. Date</em> <span>5/02/2025</span></p>
                              <p><em className='mobileOnly'>Ad Cost</em> <span>₹ 12,750 </span><i id='roSplitView' onClick={(e) => showPopover(e, 'popover-content')}></i></p>
                              <div class="posActions">
                                  <button className='viewBtn'><img src={viewIcon} alt="" />View</button>
                                  <button className='downBtn'><img src={downIcon} alt="" />Download</button>
                              </div>
                          </li>
                      </ul>

                      <button id="downloadData"><i className='downDataIcon'></i> <span>Download</span></button>
                      {isMobile && (
                          <button id="showFilters" className='mobileOnly' onClick={() => setFiltersVisible(!filtersVisible)}><i className='filtIcon'></i></button>
                      )}
                  </div>
              </div>
          </div>

          {/* Popover Modal Component */}
          <Popover 
            isVisible={popoverVisible} 
            position={popoverPosition} 
            content={popoverContent} 
            onClose={() => setPopoverVisible(false)}
          />

          <div id="popover-content" style={{ display: "none" }}>
            <h5>Total RO Split</h5>
              <ul className='posCostList'>
                  <li>
                      <h6>5/02/2025</h6>
                      <p><span>₹</span> 12,750</p>
                  </li>
                  <li>
                      <h6>16/02/2025</h6>
                      <p><span>₹</span> 22,000</p>
                  </li>
                  <li>
                      <h6>24/02/2025</h6>
                      <p><span>₹</span> 18,500</p>
                  </li>
            </ul>
          </div>
      </>
  )
 }

export default CSTDayCalendar
    